import {
    Box,
    Grid,
    IconButton,
    InputLabel,
    Switch,
    TableCell,
    tableCellClasses,
    TableRow,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ButtonContained from "../../Common/ButtonContained";
import CustomDialog from "../../Common/CustomDialog";
import CommonTextField from "../../Common/CommonTextField";
import TextLabel from "../../Common/CommonTextLabel";
import CommonFileUpload from "../../Common/CommonFileUpload";
import { useTheme } from "@emotion/react";
import { showLoader } from "../../../Redux/Slices/loaderSlice";
import { useDispatch } from "react-redux";
import {
    addBanner,
    createpress,
    delete_post,
    deleteBanner,
    get_posts,
    getallpress,
    getBanner,
    updatepress,
    updateBanner,
    uploadImage,
    deletepress,
} from "../../../Redux/Actions/action";
import ErrorHandler from "../../../Utils/handler";
import { toast } from "react-toastify";
import CustomPagination from "../../Common/CommonPagination";
import CommonTable from "../../Common/CommonTable";
import { BucketURL } from "../../../ApiSetup/Api";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DataNotFound from "../../Common/DataNotFound";
import Assets from "../../Common/Assets";
import { styled } from "@mui/material/styles";
import CommonDatePicker from "../../Common/CommonDatePicker";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { makeStyles } from "tss-react/mui";
import dayjs from "dayjs";
import ImageIcon from "@mui/icons-material/Image";

const useStyles = makeStyles()((theme) => {
    return {
        timePicker: {
            width: "100%",
            ".MuiInputBase-root:hover fieldset": {
                borderColor: `#c4c4c4 !important`,
            },
            input: {
                padding: "6px 12px 6px 12px !important",
            },
            "& .MuiInputBase-root.MuiOutlinedInput-root": {
                borderRadius: "10px !important",
                flexDirection: "row-reverse",
            },
            "& .MuiInputAdornment-root": {
                margin: "0px 5px 0px 0px",
            },
            ".Mui-focused": {
                borderColor: `red !important`,
                // borderWidth: "1px !important",
            },
            ".MuiSvgIcon-root": {
                color: "#3E4094",
                fontSize: "22px",
            },
            ".MuiInputBase-input": {
                height: "24px",
            },
        },
    };
});

const headerList = [
    "No",
    "Image",
    "Title",
    "Action",
];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme?.palette?.bgLightWhite?.main,
        fontSize: 14,
        // fontWeight: "bold",
        textAlign: "center", // Horizontally align content,
        lineHeight: "1.2rem",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: "0px 10px !important",
        textAlign: "center", // Horizontally align content
        borderBottom: "2px solid #d9d6f3",
    },
}));

function Press() {
    // ---------- Hook -----------
    const theme = useTheme();
    const dispatch = useDispatch();
    const { classes } = useStyles();

    // --------------- State -------------
    const [open, setOpen] = useState(false);
    const [isImagesPopup, setIsImagesPopup] = useState(false);
    const [data, setData] = useState({});
    const [eventList, setEventList] = useState({});
    const [error, setError] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [filePreView, setFilePreView] = useState({
        isOpen: false,
        link: "",
        type: "",
    });
    const [eventImages, setEventImages] = React.useState([]);

    // --------------- handleChange ---------------
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value.trimStart() });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setData({});
        setError({});
    };

    const validation = () => {
        let isValid = true;
        let error = {};
        if (!data.title) {
            error.title = "Title is required";
            isValid = false;
        }
        if (!data.image) {
            error.image = "Image is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    };

    // --------------- Api ---------------
    const handleImageUpload = async (e, isEventImages) => {
        const { files, name } = e?.target;

        const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
        const validTypes = [...validImageTypes];

        const fileData = files[0];
        if (!validTypes.includes(fileData.type)) {
            setError((error) => ({
                ...error,
                eventImageSize:
                    "Invalid file type. Only JPEG, PNG and JPG are allowed.",
            }));
            return;
        }

        if (fileData.size > 10485760) {
            setError((error) => ({
                ...error,
                eventImageSize:
                    "File size exceeds the 10 MB limit. Please upload a smaller file.",
            }));
            return;
        }

        const formData = new FormData();
        formData.append("image", files[0]);

        dispatch(showLoader(true));
        try {
            const result = await dispatch(uploadImage(formData));
            const error = ErrorHandler(result);

            if (error) {
                const uploadedFile = result?.payload?.data?.[0]?.image;
                if (isEventImages) {
                    setEventImages([...eventImages, uploadedFile]);
                } else {
                    setData((prevState) => ({
                        ...prevState,
                        [name]: uploadedFile,
                        isImage: validImageTypes.includes(fileData.type),
                    }));
                }

                setError((error) => ({
                    ...error,
                    eventImageSize: "",
                    bannerImage: "",
                }));
            }
        } catch (err) {
            console.error("File upload failed:", err);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const _createUpdatePosts = async () => {
        if (validation()) {
            dispatch(showLoader(true));
            try {
                let body = {
                    image: data?.image,
                    title: data?.title,
                };
                if (isEdit && data?._id) {
                    body.id = data?._id;
                    body.newsStatus = "true";
                }
                const fn = isEdit ? updatepress : createpress;
                const result = await dispatch(fn(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast.success(result?.payload?.message);
                    _getallpress();
                    handleClear();
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false));
            }
        }
    };

    const _getallpress = async () => {
        dispatch(showLoader(true));
        let body = {
            page: page,
            limit: rowsPerPage,
        };
        try {
            const result = await dispatch(getallpress(body));
            const error = ErrorHandler(result);
            if (error) {
                setEventList(result?.payload?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const _deletepress = async (id) => {
        dispatch(showLoader(true));
        try {
            const result = await dispatch(deletepress({ id: id }));
            const error = ErrorHandler(result);
            if (error) {
                toast.success(result?.payload?.message);
                _getallpress();
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    // ---------- useEffect ------------
    useEffect(() => {
        _getallpress();
    }, [page, rowsPerPage]);

    return (
        <>
            <Grid container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>
                            Press
                        </Typography>
                        <ButtonContained text={"Add Press"} onClick={() => setOpen(true)} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <CommonTable headerList={headerList} minWidth={400}>
                        {eventList?.response?.length > 0 ? (
                            eventList?.response?.map((item, index) => (
                                <TableRow key={item.id}>
                                    <StyledTableCell align="center">
                                        {(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {
                                            <img
                                                src={BucketURL + item?.image}
                                                height={"40px"}
                                                width={"40px"}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    const url =
                                                        BucketURL + item?.image;
                                                    setFilePreView({
                                                        isOpen: true,
                                                        link: url,
                                                        type: "image",
                                                    });
                                                }}
                                            />
                                        }
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {item?.title}
                                    </StyledTableCell>

                                    <StyledTableCell align="center">
                                        <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            gap={1}
                                            justifyContent={"center"}
                                        >
                                            <IconButton
                                                sx={{ padding: 0 }}
                                                onClick={() => {
                                                    setOpen(true);
                                                    setIsEdit(true);
                                                    setData(item);
                                                }}
                                            >
                                                <EditIcon fontSize="small" color="success" />
                                            </IconButton>
                                            <IconButton
                                                sx={{ padding: 0 }}
                                                onClick={() => {
                                                    _deletepress(item?._id);
                                                }}
                                            >
                                                <DeleteIcon fontSize="small" color="error" />
                                            </IconButton>
                                        </Box>
                                    </StyledTableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <StyledTableCell colSpan={8}>
                                    <DataNotFound
                                        title={"No Records Found"}
                                        icon={
                                            <ErrorOutlineIcon
                                                color="primary"
                                                style={{ fontSize: "3rem" }}
                                            />
                                        }
                                        elevation={0}
                                    />
                                </StyledTableCell>
                            </TableRow>
                        )}
                    </CommonTable>
                    {eventList?.count > 0 && (
                        <Grid item xs={12}>
                            <CustomPagination
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                count={Math.ceil(eventList?.count / rowsPerPage)}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </Grid>
                    )}
                </Grid>
                {open && (
                    <CustomDialog
                        isOpen={open}
                        handleClose={handleClear}
                        title={isEdit ? "Update Press" : "Add Press"}
                        padding={"10px"}
                        width={500}
                        action={
                            <>
                                <ButtonContained
                                    text={isEdit ? "Update Press" : "Add Press"}
                                    onClick={_createUpdatePosts}
                                    minWidth={"100%"}
                                    marginTop={"10px"}
                                />
                            </>
                        }
                    >
                        <Grid container spacing={2} xs={12} ml={-1}>
                            <Grid item xs={12}>
                                <CommonTextField
                                    value={data?.title}
                                    width={"100%"}
                                    text="Title"
                                    type="text"
                                    onChange={(e) => handleInputChange(e)}
                                    placeholder="Enter a Title"
                                    name="title"
                                    valid
                                />
                                <TextLabel
                                    title={!data?.title ? error?.title : ""}
                                    color="error"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <CommonFileUpload
                                    text={"Upload a Image"}
                                    padding={{ xs: "5px 14px", sm: "30px 14px", lg: "35px 7px" }}
                                    accept="image/jpeg, image/png, image/jpg"
                                    labelTitle="image/jpeg, image/png, image/jpg Up to 10MB"
                                    name={"image"} // This is the key that will be logged in handleUpload
                                    onChange={(e) => handleImageUpload(e)}
                                    valid
                                />
                                {data?.image && (
                                    <Assets
                                        src={BucketURL + data?.image}
                                        height={"50px"}
                                        width={"50px"}
                                        alt="Banner Image"
                                    />
                                )}
                                <TextLabel
                                    title={!data?.image ? error?.image : ""}
                                    color="error"
                                />
                                <TextLabel
                                    title={data?.eventImageSize ? "" : error?.eventImageSize}
                                    color="error"
                                />
                            </Grid>
                        </Grid>
                    </CustomDialog>
                )}
                {filePreView?.isOpen && (
                    <CustomDialog
                        isOpen={filePreView?.isOpen}
                        handleClose={() =>
                            setFilePreView({ isOpen: false, link: "", type: "" })
                        }
                        title={"View Image"}
                        padding={"5px"}
                        width={400}
                        action={
                            filePreView?.type === "image" ? (
                                <img
                                    src={filePreView?.link}
                                    alt="Preview"
                                    style={{ width: "100%" }}
                                />
                            ) : filePreView?.type === "video" ? (
                                <video controls style={{ width: "100%" }}>
                                    <source src={filePreView?.link} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            ) : (
                                <div>No media available</div>
                            )
                        }
                        maxWidth={"md"}
                    ></CustomDialog>
                )}
            </Grid>
        </>
    );
}

export default Press;
